"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toValidationError = exports.ValidationError = void 0;
var validation_error_1 = require("./validation-error");
Object.defineProperty(exports, "ValidationError", { enumerable: true, get: function () { return validation_error_1.ValidationError; } });
Object.defineProperty(exports, "toValidationError", { enumerable: true, get: function () { return validation_error_1.toValidationError; } });
